import { getModulosProgramaUniversidad, createModulosProgramaUniversidad } from '@/views/programa-viewrest-esam';

export default {
  methods: {
    moduloKey(item, index) {
      return item.programa_modulo_id || item.modulo_id || item.numero || `tmp-${index}`;
    },

    reordenarModulos() {
      if (!this.programa.programa_modulo) return;
      this.programa.programa_modulo.forEach((m, idx) => { m.numero = idx; });
    },

    addnewmodulo(flag) {
      if (!this.programa.programa_modulo) this.programa.programa_modulo = [];
      const modulos = this.programa.programa_modulo.map(x => x.numero);
      if (flag) {
        const cantidadNull = this.programa.programa_modulo.filter(x => x.programa_modulo_id < 0).length;
        const numeroMaximo = modulos.length > 0 ? Math.max(...modulos.filter(x => x != null)) : -1;
        const programa_modulo_id = -1 * (cantidadNull) - 1;
        this.programa.programa_modulo.push({ modulo_id: null, programa_modulo_id, numero: numeroMaximo + 1 });
        this.editarModulo(this.programa.programa_modulo[this.programa.programa_modulo.length - 1]);
      } else {
        this.programa.programa_modulo.pop();
      }
    },

    editarModulo(modulo) {
      this.moduloEditandoCopia = modulo;
      this.moduloEditando = modulo.programa_modulo_id || modulo.modulo_id || modulo.numero || `temp_${Date.now()}`;
      if (!modulo.programa_modulo_id && !modulo._tempId) modulo._tempId = this.moduloEditando;
    },

    guardarModulo(modulo) {
      if (!modulo.modulo_id) {
        this.$root.$notify.show('Debe seleccionar un módulo', { color: 'error' }); return;
      }
      if (!modulo.tipo_calificacion) {
        this.$root.$notify.show('Tiene que seleccionar un tipo de calificación', { color: 'error' }); return;
      }
      this.programa.programa_modulo = this.programa.programa_modulo.map(m =>
        m.programa_modulo_id === modulo.programa_modulo_id ? { ...modulo } : m
      );
      this.moduloEditando = null;
      this.moduloEditandoCopia = null;
      this.$root.$notify.show('Módulo actualizado. No olvides guardar los cambios.', { color: 'success' });
    },

    cancelarEdicion() {
      if (this.moduloEditandoCopia) {
        const index = this.programa.programa_modulo.findIndex(
          m => m.programa_modulo_id === this.moduloEditandoCopia.programa_modulo_id
        );
        if (index !== -1) this.$set(this.programa.programa_modulo, index, this.moduloEditandoCopia);
      }
      this.moduloEditando = null;
      this.moduloEditandoCopia = null;
    },

    handleDragStart(programaModulo) { this.draggedProgramaModulo = programaModulo; },
    handleDragOver() {},
    handleDrop(programaModulo) {
      if (!this.draggedProgramaModulo || this.draggedProgramaModulo === programaModulo) return;
      const lista = this.programa.programa_modulo.map(m => {
        if (m === programaModulo) return { ...m, numero: this.draggedProgramaModulo.numero };
        if (m === this.draggedProgramaModulo) return { ...m, numero: programaModulo.numero };
        return { ...m };
      });
      this.programa.programa_modulo = lista.sort((a, b) => a.numero - b.numero);
      this.$root.$notify.show('Módulos reordenados. No olvides guardar los cambios.', { color: 'info' });
    },
    handleDragEnd() { this.draggedProgramaModulo = null; },

    openeditmod(mod) {
      this.$router.push(
        `/modulo_edit?modulo_id=${mod.modulo_id}&nombre=${mod.nombre}&numero=${mod.numero}&programa_modulo_id=${mod.programa_modulo_id}`
      );
    },

    cargar_modulos_universidad() {
      const r = this.$route.query.programa_universidad_id;
      getModulosProgramaUniversidad(this, r, this.programa);
    },

    guardar_modulos_universidad() {
      const r = this.$route.query.programa_universidad_id;
      createModulosProgramaUniversidad(this, r, this.programa);
    },
  },
};
